import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex justify-center" }
const _hoisted_2 = ["viewBox"]
const _hoisted_3 = ["x1", "x2", "y2"]
const _hoisted_4 = ["y"]
const _hoisted_5 = ["x", "y", "width", "height", "fill", "onMouseenter"]
const _hoisted_6 = ["x", "y"]
const _hoisted_7 = ["x", "y", "width", "height", "fill", "onClick"]
const _hoisted_8 = ["x", "y", "transform"]
const _hoisted_9 = { class: "text-h6 font-weight-bold mb-3" }
const _hoisted_10 = { class: "whitespace-pre-line" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock("svg", {
      viewBox: `0 0 ${_ctx.svgWidth} ${_ctx.svgHeight}`,
      width: "100%"
    }, [
      (_ctx.humaneScoreColumnIndex >= 0)
        ? (_openBlock(), _createElementBlock("line", {
            key: 0,
            x1: _ctx.modelNameWidth + (_ctx.humaneScoreColumnIndex + 1) * (_ctx.cellWidth + _ctx.cellMargin) - _ctx.cellMargin / 2,
            y1: 0,
            x2: _ctx.modelNameWidth + (_ctx.humaneScoreColumnIndex + 1) * (_ctx.cellWidth + _ctx.cellMargin) - _ctx.cellMargin / 2,
            y2: _ctx.modelsCount * (_ctx.cellHeight + _ctx.cellMargin),
            stroke: "#000000",
            "stroke-width": "2",
            opacity: "0.3"
          }, null, 8, _hoisted_3))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedModels, (modelData, modelName, rowIndex) => {
        return (_openBlock(), _createElementBlock("g", {
          key: `${modelName}-${_ctx.sortColumn}-${_ctx.sortDirection}`
        }, [
          _createElementVNode("text", {
            x: 0,
            y: rowIndex * (_ctx.cellHeight + _ctx.cellMargin) + _ctx.cellHeight / 2,
            class: "font-weight-medium text-caption",
            "dominant-baseline": "middle"
          }, _toDisplayString(_ctx.getModelName(modelName)), 9, _hoisted_4),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getScores(modelData), (score, colIndex) => {
            return (_openBlock(), _createElementBlock("g", { key: colIndex }, [
              _createElementVNode("rect", {
                x: _ctx.modelNameWidth + colIndex * (_ctx.cellWidth + _ctx.cellMargin),
                y: rowIndex * (_ctx.cellHeight + _ctx.cellMargin),
                width: _ctx.cellWidth,
                height: _ctx.cellHeight,
                fill: _ctx.getScoreColor(score).backgroundColor,
                rx: "8",
                ry: "8",
                class: "cursor-pointer opacity-100 hover:opacity-80 transition-opacity",
                onMouseenter: ($event: any) => (_ctx.showTooltip(_ctx.principles[colIndex].name)),
                onMouseleave: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.hideTooltip && _ctx.hideTooltip(...args)))
              }, null, 40, _hoisted_5),
              _createElementVNode("text", {
                x: _ctx.modelNameWidth + colIndex * (_ctx.cellWidth + _ctx.cellMargin) + _ctx.cellWidth / 2,
                y: rowIndex * (_ctx.cellHeight + _ctx.cellMargin) + _ctx.cellHeight / 2,
                class: _normalizeClass(_ctx.principles[colIndex].id === 'HumaneScore' ? 'font-bold text-caption' : 'font-weight-bold text-caption'),
                style: _normalizeStyle(_ctx.principles[colIndex].id === 'HumaneScore' ? 'font-size: 13px;' : ''),
                "text-anchor": "middle",
                "dominant-baseline": "middle"
              }, _toDisplayString(_ctx.formatScore(score)), 15, _hoisted_6)
            ]))
          }), 128))
        ]))
      }), 128)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.principles, (category, index) => {
        return (_openBlock(), _createElementBlock("g", {
          key: category.id
        }, [
          _createElementVNode("rect", {
            x: _ctx.modelNameWidth + index * (_ctx.cellWidth + _ctx.cellMargin),
            y: _ctx.modelsCount * (_ctx.cellHeight + _ctx.cellMargin),
            width: _ctx.cellWidth,
            height: _ctx.labelHeight,
            fill: category.id === 'HumaneScore' ? 'rgba(59, 130, 246, 0.1)' : 'transparent',
            class: _normalizeClass(["cursor-pointer", category.id === 'HumaneScore' ? 'hover:opacity-70' : 'hover:opacity-50']),
            onClick: ($event: any) => (_ctx.handleSort(category.id))
          }, null, 10, _hoisted_7),
          _createElementVNode("text", {
            x: _ctx.modelNameWidth + index * (_ctx.cellWidth + _ctx.cellMargin) + _ctx.cellWidth / 2,
            y: _ctx.modelsCount * (_ctx.cellHeight + _ctx.cellMargin) + 10,
            "text-anchor": "end",
            "dominant-baseline": "middle",
            transform: `rotate(-45, ${_ctx.modelNameWidth + index * (_ctx.cellWidth + _ctx.cellMargin) + _ctx.cellWidth / 2}, ${_ctx.modelsCount * (_ctx.cellHeight + _ctx.cellMargin) + 10})`,
            class: _normalizeClass([
            'text-caption',
            category.id === 'HumaneScore' ? 'font-bold fill-blue-700' : 'font-weight-medium',
            _ctx.sortColumn === category.id && category.id !== 'HumaneScore' ? 'fill-blue-600 font-bold' : '',
            _ctx.sortColumn === category.id && category.id === 'HumaneScore' ? 'fill-blue-800' : ''
          ]),
            style: _normalizeStyle(category.id === 'HumaneScore' ? 'font-size: 14px;' : '')
          }, [
            _createTextVNode(_toDisplayString(category.name) + " ", 1),
            (_ctx.sortColumn === category.id)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(_ctx.sortDirection === 'desc' ? ' ↓' : ' ↑'), 1)
                ], 64))
              : _createCommentVNode("", true)
          ], 14, _hoisted_8)
        ]))
      }), 128))
    ], 8, _hoisted_2)),
    (_ctx.tooltipVisible)
      ? (_openBlock(), _createBlock(_component_v_card, {
          key: 0,
          class: _normalizeClass(["position-fixed elevation-8 rounded-lg pa-4 bg-amber-lighten-5 bottom-[40px] right-[24px] w-[340px] z-[1000] pointer-events-none transition-opacity", { 'opacity-100': _ctx.tooltipVisible, 'opacity-0': !_ctx.tooltipVisible }])
        }, {
          default: _withCtx(() => [
            _createElementVNode("h3", _hoisted_9, _toDisplayString(_ctx.popupData.name), 1),
            _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.popupData.detail), 1)
          ]),
          _: 1
        }, 8, ["class"]))
      : _createCommentVNode("", true)
  ]))
}